import { z } from 'zod';

import { type GENERATE_QSET_ERROR_CODE } from './constants';

const duplicationRateSchema = z
  // TODO: recheck with design
  .number({ message: 'กรุณากำหนดค่าความซ้ำระหว่างชุด' });

export const CheckQSetDuplicationRateFormSchema = z.object({
  duplicationRate: duplicationRateSchema,
});

export type CheckQSetDuplicationRateFormValues = z.infer<typeof CheckQSetDuplicationRateFormSchema>;

export const CheckQSetDraftToPublishDuplicationRateFormSchema = z.object({
  duplicationRate: duplicationRateSchema,
  selectedPublishedQSetIds: z.array(z.string()).min(1),
});

export type CheckQSetDraftToPublishDuplicationRateFormValues = z.infer<
  typeof CheckQSetDraftToPublishDuplicationRateFormSchema
>;

export type GenerateQSetErrorCode = keyof typeof GENERATE_QSET_ERROR_CODE;
